export default "__VITE_ASSET__B3CWAG6Y__"